import { createEndpoints } from '../../_helpers/utile/endpoint.helper';

export const LOCATIONS_ENDPOINTS = {
  V1: createEndpoints('v1', {
    ADDRESS_LOCATIONS: '/address-locations/',
    REGIONS: (country_pk: number) => `/regions/${country_pk}`,
    CITIES: (region_pk: number) => `/cities/${region_pk}/`,
    ALL_CITIES: '/all-cities/',
    ALL_REGIONS: '/all-regions/',
    DISTRICTS: (city_pk: number) => `/cities/${city_pk}/districts/`,
  }),
  V2: createEndpoints('v2', {
    NATIONAL_ADDRESS: `/national-address/`,
  }),
} as const;
